import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { generateCacheKey, withManualCache } from '@/utlility/cache-service';
const API_URL = process.env.NEXT_PUBLIC_API_URL;


export const fetchFAQs = createAsyncThunk(
  'faq/fetchFAQs',
  async ({payload}, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/faqs`;
      const cacheKey = generateCacheKey(url, 'POST', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.post(url, payload);
        return response.data;
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue({ message: errorMessage });
    }
  }
);

const faqSlice = createSlice({
  name: 'faq',
  initialState: {
    faqs: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFAQs.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFAQs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.faqs = action.payload.data;
      })
      .addCase(fetchFAQs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default faqSlice.reducer;
